import { Suspense } from "react";
import Spinner from "react-bootstrap/Spinner";

// component imports

const Loadable = (Component) => (props) =>
  (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
            height: "100vh", // Full viewport height
            width: "100%", // Full viewport width
          }}
        >
          <Spinner
            animation="border"
            size="md"
            variant="success"
            style={{
              display: "flex", // Use flexbox
              justifyContent: "center", // Center horizontally
              alignItems: "center",
            }}
          />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );

export default Loadable;
